<template>
    <or-layout>
        <a-row :gutter="[16, 16]" type="flex" justify="space-between">

            <a-col>
                <a-form layout="inline">
                    <a-form-item>
                        <a-select v-model="searchFrom.org_id" style="width: 240px" placeholder="机构ID"
                            @change="getCampusList">
                            <a-select-option value="">全部</a-select-option>
                            <a-select-option v-for="(item) in org" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.campus_id" style="width: 240px" placeholder="校区ID">
                            <a-select-option value="">全部</a-select-option>
                            <a-select-option v-for="(item) in campus" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                            :placeholder="['开始时间', '结束时间']" @change="onChange" />
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.isteacher" placeholder="老师/班主任" allow-clear style="width: 120px;">
                            <a-select-option :key="2" :value="2">老师</a-select-option>
                            <a-select-option :key="1" :value="1">班主任</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.year" placeholder="年份" allow-clear style="width: 120px;">
                            <a-select-option :key="2021" :value="2021">2021年</a-select-option>
                            <a-select-option :key="2022" :value="2022">2022年</a-select-option>
                            <a-select-option :key="2023" :value="2023">2023年</a-select-option>
							<a-select-option :key="2024" :value="2024">2024年</a-select-option>
							<a-select-option :key="2025" :value="2025">2025年</a-select-option>
							<a-select-option :key="2026" :value="2026">2026年</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.month" placeholder="月份" allow-clear style="width: 120px;">
                            <a-select-option :key="1" :value="1">1月</a-select-option>
                            <a-select-option :key="2" :value="2">2月</a-select-option>
                            <a-select-option :key="3" :value="3">3月</a-select-option>
                            <a-select-option :key="4" :value="4">4月</a-select-option>
                            <a-select-option :key="5" :value="5">5月</a-select-option>
                            <a-select-option :key="6" :value="6">6月</a-select-option>
                            <a-select-option :key="7" :value="7">7月</a-select-option>
                            <a-select-option :key="8" :value="8">8月</a-select-option>
                            <a-select-option :key="9" :value="9">9月</a-select-option>
                            <a-select-option :key="10" :value="10">10月</a-select-option>
                            <a-select-option :key="11" :value="11">11月</a-select-option>
                            <a-select-option :key="12" :value="12">12月</a-select-option>
                        </a-select>
                    </a-form-item>


                    <a-form-item>
                        <a-input placeholder="姓名" v-model="searchFrom.teacher_name" @keyup.enter="tableSearch"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                    </a-form-item>

                </a-form>
            </a-col>
        </a-row>
        <a-divider></a-divider>
        <div>
            <a-button @click="exportData">导出</a-button>
            <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" @change="onPaginationChange"
                bordered>
                <a-table-column key="teacher_name" title="老师名字" data-index="teacher_name" />
                <!--  <a-table-column key="class_teacher_name" title="班主任名字" data-index="class_teacher_name" /> -->
                <a-table-column key="salary_money" title="工资" data-index="salary_money"
                    :sorter="(item1, item2) => item1.salary_money - item2.salary_money" />
                <a-table-column key="active" width="220px" title="操作">
                    <template slot-scope="item">
                        <teacherwageinfomode v-bind:itemdata="item"></teacherwageinfomode>
                        <!--                        <a-button @click="changeStatus({id:item.id,status:1,pid:item.pid})" class="active_btn"
                            size="small" type="link">详情
                        </a-button> -->

                    </template>
                </a-table-column>
            </a-table>
        </div>
    </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
import teacherwageinfomode from '@/views/performance/teacherwageinfomode.vue';


export default {
    components: {
        AFormItem,
        teacherwageinfomode
    },
    data() {
        let nowDate = new Date()
        return {
            data: [],
            org: [],
            campus: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 99
            },
            searchFrom: {
                teacher_name: "",
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                org_id: "",
                campus_id: '',
                start_time: '',
                end_time: '',
                isteacher: 1,
                export: 0

            },
        };
    },

    mounted() {
        this.getOrgList();
        this.getCampusList();
        this.tableSearch();

    },
    methods: {
        // 获取机构ID
        getOrgList() {
            this.$axios
                .post("/api/admin/get_my_org_list", {})
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.org = res.data;
                        if (this.org.length > 0) {
                            this.searchFrom.org_id = this.org[0].id;
                        } else {
                            this.$error({
                                title: "错误",
                                content: "你没有可查看的机构",
                                okText: "确定"
                            });

                        }
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCampusList() {
            // let that = this;
            let Campusdata = {};
            if (this.searchFrom.org_id) {
                Campusdata = {
                    org_id: this.searchFrom.org_id
                };
            }
            this.$axios
                .post("/api/admin/get_my_campus_list", {
                    data: Campusdata
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.campus = res.data;
                        if (this.campus.length === 1) {
                            this.searchFrom.campus_id = this.campus[0].id;
                        }
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        onChange(value, dateString) {
            dateString,
                this.searchFrom.start_time = Number(value[0] / 1000);
            this.searchFrom.end_time = Number(value[1] / 1000);

        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.tableSearch();
        },
        tableSearch() {
            this.getTableList(this.searchFrom);
        },

        getTableList() {
            this.$axios
                .post("/api/TeacherPerformance/getPerformance", {
                    data: this.searchFrom
                    ,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.data = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

        exportData() {
            this.searchFrom.export = 1;
            this.$axios
                .post("/api/TeacherPerformance/getPerformance", {
                    data: this.searchFrom
                    ,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    this.searchFrom.export = 0;
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        window.open(res.data);
                        // this.data = res.data.data;
                        // this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
